import React, { useEffect, useState } from 'react';

import { Form } from 'react-bootstrap';

/* import fetch function */
import { FetchUserRole } from "../services/options";
import { FetchMemberEvent } from "../services/member";
import { FetchMessageSettingDropdown } from "../services/message";
import { FetchSelectSource } from "../services/constant";

const Select = ({ size = 'md', select_all = true, name, label, options = [], _default, shadow = true, disabled = false, required = false, changHandle }) => {
    const [selected, setSelected] = useState();
    const [optionItem, setOption] = useState(options);

    const arrangeOptions = response => {
        const lists = [];

        response.forEach(({ name, rId }) => {
            lists.push({ key: rId, value: name });
        });

        return lists;
    };

    useEffect(() => {
        if (!selected && _default)
            setSelected(_default);
    }, [ optionItem ]);

    useEffect(() => {
        if (selected && optionItem.length) {
            const isSelected = optionItem.find(({ key }) => key === selected);
            
            if (!isSelected) {
                setSelected(`${isSelected}`);
            }
        }
    }, [ options ]);

    useEffect(() => {
        if (selected && !disabled)
            changHandle({target: {name: name, value: selected}});
        
        if (name === 'rId') {
            FetchUserRole().then(response => {
                const lists = arrangeOptions(response);

                setOption(lists);
            });
        }

        if (name === 'epId') {
            FetchMemberEvent().then(response => {
                const _options = [];
    
                response.forEach(item => {
                    const option = {
                        key: item.epId,
                        value: item.eventName,
                        point: item.point
                    }
                    
                    _options.push(option);
                });

                setOption(_options);
            });
        }

        if (name === 'messageTime') {
            FetchMessageSettingDropdown().then(response => {
                const _options = [];
    
                response.forEach(item => {
                    const option = {
                        key: item.codeId,
                        value: item.time,
                    }
                    
                    _options.push(option);
                });

                setOption(_options);
            });
        }

        if (name === 'deviceType') {
            constantSelectSource('device');
        }

        if (name === 'pointType') {
            constantSelectSource('point');
        }
        if (name === 'fcmType') {
            constantSelectSource('fcmType');
        }
    }, []);

    const constantSelectSource = async type => {
        const _options = [];
        const response = await FetchSelectSource({ type });

        response.forEach(item => {
            const option = {
                key: item.codeId,
                value: item.codeValue
            }
            
            _options.push(option);
        });

        setOption(_options);
    };


    const changHandler = ({ target }) => {
        
        if (changHandle && name === 'epId') {
            const { point } = optionItem?.find(({ key }) => key === target.value) || { point: 0 };
            
            changHandle({ target, point });
        }
        else if (changHandle && (name === 'deviceType' || name === 'pointType'|| name === 'messageType')) {
            changHandle({ target: { name: 'codeId', value: target.value } });
        }
        else if (changHandle)
            changHandle({ target });

        setSelected(target.value);
    }

    return (        
        <Form.Select size={ size } data-shadow={ shadow } name={ name } value={ selected } disabled={ disabled } is-required={`${required}`} onChange={ changHandler }>
            <option hidden>{ label || '請選擇' }</option>
            <option hidden={ !select_all || !optionItem?.length } value="">All</option>
            {
                optionItem?.map(({ key, value, point }) => (
                    key && <option key={`${ key }`} value={ key } >{ value }</option>
                ))
            }
        </Form.Select>
    )
}

export default React.memo(Select);
